import axios from '../../axios';
import * as actionTypes from '../actions/actionTypes';
import {reset} from 'redux-form';
import {fetchMaritalValuesSuccess} from "./fetchRefValues";

export const insertFormSuccess = (message, status) => {
    return {
        type: actionTypes.INSERT_FORM_SUCCESS,
        message: message,
        status: status
    };
};

export const insertFormFail = (message, status) => {
    return {
        type: actionTypes.INSERT_FORM_FAIL,
        message: message,
        status: status
    };
};

export const insertFormRemoveMessage = () => {
    return {
        type: actionTypes.REMOVE_MESSAGE_INSERT_FORM,
    };
};

export const insertForm =(code, gender, weight, height, department, age, marital, academic, smokersV, smokersF,
                          smokersA, smokersT, healthO, sleepO, sleep, chronicO, meal, breakfast, fruit, vegetables,
                          sodas, fastF, walking_cycling, sist, dist, pulse, uric, glucose, colestherol, meds, medsN,
                          painV, painL, painS, physicalV, physicalH, spiro, visual, auditory, ecg, eritrogram, leukogram,
                          has_chronic, takes_meds, has_physical, spirometry_value, visual_screening_value,
                          auditory_screening_value, ecg_value, eritrogram_value, leukogram_value, alcoholOption,
                          beer, wine, spiritDrinks) => {
    return dispatch => {
        if(physicalV == ''){
            physicalV = null;
        }

        const insertData = {
            code: code,
            gender: gender,
            weight: weight,
            height: height,
            department: department,
            age: age,
            marital: marital,
            academic: academic,
            smokersV: smokersV,
            smokersF: smokersF,
            smokersA: smokersA,
            smokerT: smokersT,
            healthO: healthO,
            sleepO: sleepO,
            sleep: sleep,
            chronicO: chronicO,
            meal: meal,
            breakfast: breakfast,
            fruit: fruit,
            vegetables: vegetables,
            sodas: sodas,
            fastF: fastF,
            walking_cycling: walking_cycling,
            sist: sist,
            dist: dist,
            pulse: pulse,
            uric: uric,
            glucose: glucose,
            colestherol: colestherol,
            meds:meds,
            medsN:medsN,
            painV:painV,
            painL:painL,
            painS:painS,
            physicalV: physicalV,
            physicalH: physicalH,
            spiro: spiro,
            visual: visual,
            auditory:auditory,
            ecg: ecg,
            eritrogram: eritrogram,
            leukogram:leukogram,
            has_chronic: has_chronic,
            takes_meds: takes_meds,
            has_physical: has_physical,
            spirometry_value: spirometry_value,
            visual_screening_value: visual_screening_value,
            auditory_screening_value: auditory_screening_value,
            ecg_value: ecg_value,
            eritrogram_value: eritrogram_value,
            leukogram_value: leukogram_value,
            alcoholOption: alcoholOption,
            beer: beer,
            wine: wine,
            spiritDrinks: spiritDrinks,
        };
        return axios.post('admin/insertForm', insertData)
            .then(response => {
                console.log("status----> " + response.data.status);
                if (response.data.status === 0) {
                    dispatch(insertFormFail(response.data.message, response.data.status));
                    return false;
                } else {
                    console.log(response.data);
                    dispatch(insertFormSuccess(response.data.message, response.data.status));
                    return true;
                }
            })
            .catch(err => {
                console.log(err);

                dispatch(insertFormFail());
                return false;
            })
    }
};

export const fetchSearchCodeSuccess = (searchCode) => {
    return {
        type: actionTypes.FETCH_SEARCHCODE_SUCCESS,
        searchCode: searchCode
    }
};

export const searchCode = () => {
    return dispatch => {
        axios.get('ref_values/searchcode')
            .then(response => {
                dispatch(fetchSearchCodeSuccess(response.data.searchCode.results));
            })
            .catch(err => {
                console.log(err)
            })
    }
};

export const fetchAdminNullValuesStart = () => {
    return {
        type: actionTypes.FETCH_ADMIN_FORM_NULL_VALUES_START
    };
};

export const fetchAdminNullValuesSuccess = (editNullValues, editStatus_null) => {
    return {
        type: actionTypes.FETCH_ADMIN_FORM_NULL_VALUES_SUCCESS,
        editNullValues: editNullValues,
        editStatus_null: editStatus_null
    };
};

export const fetchAdminNullValuesFail = (message_null, editStatus_null) => {
    return {
        type: actionTypes.FETCH_ADMIN_FORM_NULL_VALUES_FAIL,
        message_null: message_null,
        editStatus_null: editStatus_null
    };
};

export const AdminNullValuesMsgRemove = () => {
    return {
        type: actionTypes.ADMIN_FORM_NULL_REMOVE_MESSAGE
    };
};

export const fetchAdminNullValues = (code) => {
    return dispatch => {
        dispatch(fetchAdminNullValuesStart());
        axios.get('admin/editValues/' + code)
            .then(response => {
                if (response.data.status === 1) {
                    dispatch(fetchAdminNullValuesSuccess(response.data.message[0], response.data.status));
                } else {
                    dispatch(fetchAdminNullValuesFail(response.data.message, response.data.status));
                }
            })
            .catch(err => {
                console.log(err)
            })
    };
};

export const fetchLoginLogsSuccess = (loginLogs) => {
    return {
        type: actionTypes.FETCH_LOGIN_LOGS_SUCCESS,
        loginLogs: loginLogs
    }
};

export const loginLogs = () => {
    return dispatch => {
        axios.get('admin/loginlogs')
            .then(response => {
                dispatch(fetchLoginLogsSuccess(response.data.message));
            })
            .catch(err => {
                console.log(err)
            })
    }
};

export const fetchAllUserEmailsSuccess = (allUserEmails) => {
    return{
        type: actionTypes.FETCH_ALL_USER_EMAILS_SUCCESS,
        allUserEmails: allUserEmails
    }
};

export const fetchAllUserProfilesSuccess = (allUserProfiles) => {
    return{
        type: actionTypes.FETCH_ALL_USER_PROFILES_SUCCESS,
        allUserProfiles: allUserProfiles
    }
};

export const allUserProfiles = () => {
    return dispatch => {
        axios.get('admin/allUserProfiles/')
            .then(response => {
                //console.log(response.data.allUserProfiles);
                //console.log(response.data.allUserEmails);
                dispatch(fetchAllUserEmailsSuccess(response.data.allUserEmails));
                dispatch(fetchAllUserProfilesSuccess(response.data.allUserProfiles));

            })
            .catch(err => {
                console.log(err);
            })
    }
};


export const fetchAllProfilesSuccess = (allProfiles) => {
    return {
        type: actionTypes.FETCH_ALL_PROFILES_SUCCESS,
        allProfiles: allProfiles

    }
};

export const allProfiles = () => {
    return dispatch => {
        axios.get('admin/allProfiles')
            .then(response => {
                //console.log(response.data.allProfiles);
                dispatch(fetchAllProfilesSuccess(response.data.allProfiles))
            })
    }
};







// WEBPACK FOOTER //
// ./src/store/actions/admin.js